export default function VerticalTabs({key, onClick, title, selectedTab}: any) {
  return (
    <>
      {/* <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
        <li
          key={index}
          className={
            `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
            (sidebar === index + 1
              ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
              : '')
          }
          onClick={() => setSidebar(index + 1)}
        >
          {sideTabs}
        </li>
      </ul> */}
      <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
        <li
          key={key}
          className={
            `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
            (selectedTab
              ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
              : '')
          }
          onClick={onClick}
        >
          {title}
        </li>
      </ul>
    </>
  )
}
